import Games from '../../components/WhatsNewModal/resources/Games.png';
import NewAvatars from '../../components/WhatsNewModal/resources/NewAvatars.png';
import NewLook from '../../components/WhatsNewModal/resources/NewLook.png';
import Sapphires from '../../components/WhatsNewModal/resources/Sapphires.png';
import StandardPricing from '../../components/WhatsNewModal/resources/StandardPricing.png';

const whatsNewPageContent = [
  {
    key: 'feature-1',
    header: 'A Fresh, New Look',
    content:
      "We're thrilled to announce a colorful update to our website, bringing the award-winning aesthetics of our Casinoverse app to your browsers. Say goodbye to the old and welcome a sleek, modern design that not only looks great but is easier to use and includes more mobile features.",
    contentImg: NewLook
  },
  {
    key: 'feature-2',
    header: 'New Avatars',
    content:
      "Your online Wind Creek persona is about to get a serious upgrade!  To ensure a safe and welcoming environment, we've moved away from user-uploaded images and now offer a diverse range of preselected avatars, reflecting the vibrant community at Wind Creek Casino. These avatars are just the beginning. We're committed to expanding these options, and plan on offering more customization features in the future.",
    contentImg: NewAvatars
  },
  {
    key: 'feature-3',
    header: 'Standardized Pricing',
    content:
      "We've heard your feedback about our pricing model in the WStore. Many of you have been frustrated with fluctuating prices. To enhance your WStore experience, we're transitioning to fixed prices for all users. From now on, the price you see is the price you get, barring special promotions. This change means no more surprises or frustrations with fluctuating prices, making your journey in our store straightforward and enjoyable.",
    contentImg: StandardPricing
  },
  {
    key: 'feature-4',
    header: 'Sapphires',
    content:
      'Sapphires are a new virtual currency, previously exclusive in Casinoverse, you can now use in the WStore. You earn Sapphires by playing your favorite casino games on WindCreekCasino.com in the Casinoverse app. Sapphires are awarded on your online and on property play. This currency not only adds an extra layer of fun to your gaming experience but also offers a new way to redeem offers like FREE Play. Plus, you can trade WScore for Sapphires directly in the WStore. Look for the Trade button on eligible items and start maximizing your rewards.',
    contentImg: Sapphires
  },
  {
    key: 'feature-5',
    header: '40+ New Games',
    content:
      "We're expanding your play options with over 40 new casino-style games, previously exclusive to the Casinoverse app. Now available on the web, these games offer more variety, excitement, and opportunities to earn. Whether you're a fan of slots, card games, or something entirely new, there's something for everyone. Get ready to explore and enjoy these fresh additions!",
    contentImg: Games
  }
];

export default whatsNewPageContent;
